import cx from "classnames";
import { LoadingIcon } from "components/icons";
import { useOutsideClick } from "hooks";
import { useCallback } from "react";

export type ExportDropdownItem = {
  label: string;
  isExporting: boolean;
  onAction: (index: number) => void;
};

type ExportDropdownButtonProps = {
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
  id: number;
  items: ExportDropdownItem[];
  isOpen: boolean;
  onOpenChange: (id: number) => void;
};

const ExportDropdownButton: React.FC<ExportDropdownButtonProps> = ({
  Icon,
  id,
  items,
  isOpen,
  onOpenChange,
}) => {
  const handleCloseDropdown = useCallback(() => {
    if (isOpen) onOpenChange(id);
  }, [id, isOpen, onOpenChange]);

  const ref = useOutsideClick<HTMLDivElement>(handleCloseDropdown);

  const handleOpenChange = () => {
    onOpenChange(id);
  };

  return (
    <div className="hover:cursor-pointer relative overflow-visible" ref={ref}>
      <button
        className={cx(
          "text-neutral-100 hover:text-turquoise-75  focus:text-turquoise-75 disabled:text-neutral-25 px-4 py-2",
          {
            "text-turquoise-75": isOpen,
          },
        )}
        onClick={handleOpenChange}
      >
        <Icon />
      </button>
      {isOpen && (
        <div className="absolute top-[40px] overflow-visible right-0 border  border-neutral-25 bg-neutral-0 p-2 rounded-lg flex flex-col gap-2 z-10 shadow-md">
          {items.map(({ label, isExporting, onAction }, index) => {
            return (
              <div
                className={cx(
                  "w-[320px] h-10 pl-4 rounded-md hover:bg-neutral-15 flex items-center body-16-regular gap-4",
                  {
                    "hover:bg-transparent cursor-not-allowed": isExporting,
                  },
                )}
                key={index}
                onClick={() => {
                  if (isExporting) return;
                  onAction(index);
                }}
              >
                {isExporting && <LoadingIcon className="animate-spin" />}

                {label}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ExportDropdownButton;
